import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";
import auth from "../../../auth";
import axios from "axios";

import { Table, Nav, NavItem, NavLink, Row, Col, Label, Input, InputGroup, FormFeedback } from 'reactstrap';
import InputMask from 'react-input-mask';

import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"
import ParadigmaLabeledInput from "../../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js"
import AgregarCosto from "./AgregarCosto.js"

import DetailEmpresas from "../../clientes/Empresas/Detail.js"

import DetailLTA from "../../clientes/Responsables/Detail.js"

import dateFunctions from '../../functions/dateFunctions';

var columnStyle = {
    minWidth: "125px",
    maxWidth: "125px"
}

var columnStyleObs = {
    minWidth: "200px",
    maxWidth: "200px"
}
var FieldStyle = {
    maxWidth: "100%"
}

class Detail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            uvt_id: null,
            ott_id: null,
            solicitud_id: null,
            plan_id: null,
            condiciondepago_id: null,
            plazo_id: null,
            plazoDeEntrega_id: null,
            lae_id: null,
            empresa_id: null,
            costos: [],
            nro: 'P0000-00',
            nro: 'AA0000',
            valorReferencia: 0,
            ecuacion: "",
            coeficienteGC: 0,
            coeficienteUE: 0,
            ivaIncluido: 1,
            precioFinal: '',
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        id: PropTypes.func.isRequired,
    }

    resetState() {
        this.setState({
            uvt_id: null,
            ott_id: null,
            solicitud_id: null,
            plan_id: null,
            condiciondepago_id: null,
            plazo_id: null,
            plazoDeEntrega_id: null,
            lae_id: null,
            empresa_id: null,
            costos: [],
            nro: 'P0000-00',
            nro: 'AA0000',
            valorReferencia: 0,
            ecuacion: "",
            coeficienteGC: 0,
            coeficienteUE: 0,
            ivaIncluido: 2,
            precioFinal: '',
        })
    }

    setSelects(data) {
        this.setState({
            uvt_id: data.uvt_id,
            ott_id: data.ott_id,
            solicitud_id: data.solicitud_id,
            plan_id: data.plan_id,
            condiciondepago_id: data.condiciondepago_id,
            plazo_id: data.plazo_id,
            plazoDeEntrega_id: data.plazoDeEntrega,
            lae_id: data.lae_id,
            empresa_id: data.empresa_id,
            costos: data.costos,
            nro: data.nro,
            codigo: data.codigo,
            valorReferencia: data.valorReferencia,
            ecuacion: data.ecuacion,
            coeficienteGC: data.coeficienteGC,
            coeficienteUE: data.coeficienteUE,
            ivaIncluido: data.ivaIncluido,
            precioFinal: data.valorfinal,
        });
    }

    onChangeInput(tabN, input) {
        var i = parseInt(tabN);
        var newCostos = this.state.costos;
        newCostos[i].value = input.value;
        this.setState({ costos: newCostos });
    }

    onChangeInputObs(tabN, input) {
        var i = parseInt(tabN);
        var newCostos = this.state.costos;
        newCostos[i].obs = input.value;
        this.setState({ costos: newCostos });
    }

    UpdateCostos(costos) {
        var newCostos = [];
        for (var i = 0; i < costos.length; i++) {
            var newCosto = costos[i];
            var oldCosto = this.state.costos.filter(x => x.pk == newCosto.pk);
            newCostos.push(
                {
                    pk: newCosto.pk,
                    nombre: newCosto.nombre,
                    value: (oldCosto.length > 0 ? oldCosto[0].value : 0),
                    obs: (oldCosto.length > 0 ? oldCosto[0].obs : ""),
                }
            );
        }
        this.setState({ costos: newCostos });
    }

    render() {
        const { valorReferencia, precioFinal } = this.state;
        var costoTotal = 0;
        var atr = [];

        if (this.state.costos) {
            let lastpk = 0;
            for (var i = 0; i < this.state.costos.length; i++) {
                let rowN = i.toString();
                var row = this.state.costos[i];
                costoTotal += parseFloat(row.value);
                atr.push(
                    <tr key={i}>
                        <th className="d-none" scope="row">
                            <Input type="number" name={"costos[" + rowN + "][id]"} className="p-0 d-none" value={row.pk} onChange={(e) => this.onChangeInput(rowN, e.target)} />
                        </th>
                        <td className={(row.pk != lastpk ? "" : "border-0")} >
                            {(row.pk != lastpk ?
                                row.nombre
                                : "")}
                        </td>
                        <td className={(row.pk != lastpk ? "" : "border-0") + " " + "d-none d-sm-block"}>
                            <Input disabled={true} type="text" name={"costos[" + rowN + "][obs]"} value={row.obs} onChange={(e) => this.onChangeInputObs(rowN, e.target)} className="form-control text-left" />
                        </td>
                        <td className={(row.pk != lastpk ? "" : "border-0")}>
                            <Input disabled={true} type="text" name={"costos[" + rowN + "][valor]"} value={(row.value % 1 == 0) ? (dateFunctions.formatCurrencySDecimales(row.value)) : (dateFunctions.formatCurrency(row.value))} onChange={(e) => this.onChangeInput(rowN, e.target)} className="form-control text-right" />
                        </td>
                    </tr>
                );
                lastpk = row.pk;
            }
        }

        return (
            <ParadigmaModal
                getUrl={api.proyectos.presupuesto.cerrar}
                postUrl={api.proyectos.presupuesto.cerrar}
                onSubmit={() => this.props.onSubmit()}
                id={this.props.id}
                successMessage={"El Presupuesto ha sido enviado con éxito."}
                notAllowedMessage={"El Presupuesto ya ha sido enviado."}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Enviar Presupuesto a OTT"}
                buttonTitle={"Enviar Presupuesto a OTT"}
                buttonIcon={"fa fa-envelope fa-lg"}
                saveButton={true}
                buttonClass={"btn-success"}
                saveButtonLabel={"Enviar"}
                closeButton={true}
                onGotData={(data) => this.setSelects(data)}
                onClose={() => this.resetState()}
            >
                <Input type="hidden" name="plan_id" disabled={true} />
                <ParadigmaLabeledInput
                    disabled
                    label={"Proyecto"}
                    fieldName=""
                    labelColumns={2}
                    fieldColumns={10}
                    inputComponent={
                        <Row noGutters>
                            <Col className="col-3 col">
                                {this.state.codigo &&
                                    <InputMask disabled={true} className="form-control" value={this.state.codigo} type="text" />
                                }
                            </Col>
                            <Col className="col-9 col pl-4">
                                <ParadigmaAsyncSeeker fieldName={"solicitud_id"}
                                    url={api.proyectos.solicitudes.select} value={this.state.solicitud_id} disabled={true} />
                            </Col>
                        </Row>
                    }
                />

                <ParadigmaLabeledInput
                    disabled
                    label={"Oficina de Transf. Técnica"}
                    fieldName=""
                    labelColumns={5}
                    fieldColumns={7}
                    inputComponent={
                        <ParadigmaAsyncSeeker disabled={true} fieldName={"ott_id"} url={api.proyectos.config.presupuesto.ott.select}
                            onChange={(e) => this.setState({ ott_id: e.pk })} value={this.state.ott_id} />
                    }
                />


                <ParadigmaLabeledInput
                    disabled
                    label={"Unidad de Vinculación"}
                    fieldName=""
                    labelColumns={5}
                    fieldColumns={7}
                    inputComponent={
                        <ParadigmaAsyncSeeker disabled={true} fieldName={"uvt_id"} url={api.proyectos.config.presupuesto.uvt.select}
                            onChange={(e) => this.setState({ uvt_id: e.pk })} value={this.state.uvt_id} />
                    }
                />

                <ParadigmaLabeledInput
                    disabled
                    label={"Empresa/Organización"}
                    fieldName=""
                    labelColumns={5}
                    fieldColumns={7}
                    inputComponent={
                        <ParadigmaAsyncSeeker Detail={DetailEmpresas} fieldName={"empresa_id"} url={api.clientes.empresas.select}
                            value={this.state.empresa_id} disabled={true} />
                    }
                />

                {
                    this.state.empresa_id &&
                    <ParadigmaLabeledInput
                        disabled
                        label={"Contacto del Cliente"}
                        fieldName=""
                        labelColumns={5}
                        fieldColumns={7}
                        inputComponent={
                            <ParadigmaAsyncSeeker Detail={DetailLTA} disabled={true} fieldName={"lae_id"} nombreField={"fullname"}
                                url={api.clientes.responsables.select + "?empresa_id=" + this.state.empresa_id} value={this.state.lae_id} />
                        }
                    />
                }

                <ParadigmaLabeledInput
                    disabled
                    label={"Moneda de Pago"}
                    fieldName=""
                    labelColumns={5}
                    fieldColumns={7}
                    inputComponent={
                        <ParadigmaAsyncSeeker fieldName={"condiciondepago_id"} url={api.proyectos.config.presupuesto.condiciones.select}
                            value={this.state.condiciondepago_id} disabled={true} />
                    }
                />

                <Row className="mt-1">
                    <Col className="col-12">
                        <Table className=" table-sm">
                            <thead>
                                <tr>
                                    <th className="d-none">#</th>
                                    <th className="col-3 align-middle">Costos</th>
                                    <th className="col-6 d-none d-sm-block" style={columnStyleObs}>
                                        <div className="d-inline-block w-50 align-middle">Obs</div>
                                    </th>
                                    <th className="col-3" style={columnStyle}>
                                        <div className="d-inline-block w-50 align-middle">Valor</div>
                                        <div className="d-inline-block text-right w-50"> </div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {atr}
                            </tbody>
                        </Table>
                    </Col>
                </Row>


                <ParadigmaLabeledInput disabled marginLeftAuto labelClassName="text-right" type={"number"}
                    label={"Costo del Proyecto"} fieldName="" labelColumns={8} fieldColumns={4} value={(costoTotal % 1 == 0) ? (dateFunctions.formatCurrencySDecimales(costoTotal)) : (dateFunctions.formatCurrency(costoTotal))} />


                <ParadigmaLabeledInput disabled marginLeftAuto labelClassName="text-right" type={"number"}
                    label={"Valor de Referencia"}
                    fieldName="" labelColumns={8} fieldColumns={4}
                    tooltipHeader={"Calculado con"}
                    tooltip={<div>
                        <div>V.R. = {this.state.ecuacion}</div>
                        <div>GC = {this.state.coeficienteGC}</div>
                        <div>UE = {this.state.coeficienteUE}</div>
                    </div>}
                    value={(valorReferencia % 1 == 0) ? (dateFunctions.formatCurrencySDecimales(valorReferencia)) : (dateFunctions.formatCurrency(valorReferencia))} />


                <ParadigmaLabeledInput disabled marginLeftAuto labelClassName="text-right" type={"number"}
                    label={"Precio"} style={{ fontWeight: 800 }} fieldName="valorfinal" labelColumns={8} fieldColumns={4}
                    value={(precioFinal % 1 == 0) ? (dateFunctions.formatCurrencySDecimales(precioFinal)) : (dateFunctions.formatCurrency(precioFinal))}  />

                <Row>
                    <Col className="col-md-7 ml-auto row">
                        <Label className={"mr-4"}><input disabled type={"radio"} checked={this.state.ivaIncluido == 1} /> +IVA</Label>
                        <Label className={"mr-4"}><input disabled type={"radio"} checked={this.state.ivaIncluido == 2} /> IVA incluido</Label>
                        <Label className={""}><input disabled type={"radio"} checked={this.state.ivaIncluido == 3} /> Exento</Label>
                    </Col>
                </Row>

                <ParadigmaLabeledInput
                    disabled
                    label={"Forma de Pago"} fieldName="formaDePago"
                    labelColumns={3} fieldColumns={9} />

                <ParadigmaLabeledInput
                    disabled
                    label={"Validez de Oferta"} fieldName="validezDeOferta"
                    labelColumns={3} fieldColumns={9} />

                <ParadigmaLabeledInput
                    disabled
                    label={"Plazo de Entrega"}
                    fieldName="plazoDeEntrega"
                    labelColumns={3} fieldColumns={9}
                    onChange={(e) => this.setState({ plazoDeEntrega_id: e.target.value })} 
                    value={this.state.plazoDeEntrega_id}
                />

                <ParadigmaLabeledInput disabled type={"textarea"}
                    label={"Observaciones"} fieldName="observaciones" labelColumns={12} fieldColumns={12} />

            </ParadigmaModal>
        );
    }
}

export default Detail;



// WEBPACK FOOTER //
// ./src/views/Proyectos/Procedimiento3/Cerrar.js